// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ecda7f7d","879":"60d1e3f4"}[chunkId] + ".chunk.js";
};